import add from "../assets/icons/dark/add.svg";
import menu from "../assets/icons/dark/menu.svg";
import close from "../assets/icons/dark/close.svg";
import more from "../assets/icons/dark/more.svg";
import deleteIcon from "../assets/icons/dark/delete.svg";
import copy from "../assets/icons/dark/copy.svg";
import edit from "../assets/icons/dark/edit.svg";
import forward from "../assets/icons/dark/forward.svg";
import backward from "../assets/icons/dark/backward.svg";
import check from "../assets/icons/dark/check.svg";
import cancel from "../assets/icons/dark/cancel.svg";
import generate from "../assets/icons/dark/generate.svg";
import tag from "../assets/icons/dark/tag.svg";
import tags from "../assets/icons/dark/tags.svg";
import dropdown from "../assets/icons/dark/dropdown.svg";
import dropup from "../assets/icons/dark/dropup.svg";
import chevronDown from "../assets/icons/dark/chevron-down.svg";
import settings from "../assets/icons/dark/settings.svg";
import cloud from "../assets/icons/dark/cloud.svg";
import lock from "../assets/icons/dark/lock.svg";
import unlock from "../assets/icons/dark/unlock.svg";
import refresh from "../assets/icons/dark/refresh.svg";
import exportIcon from "../assets/icons/dark/export.svg";
import importIcon from "../assets/icons/dark/import.svg";
import search from "../assets/icons/dark/search.svg";
import info from "../assets/icons/dark/info.svg";
import infoRound from "../assets/icons/dark/info-round.svg";
import download from "../assets/icons/dark/download.svg";
import upload from "../assets/icons/dark/upload.svg";
import show from "../assets/icons/dark/show.svg";
import hide from "../assets/icons/dark/hide.svg";
import checked from "../assets/icons/dark/checked.svg";
import checkall from "../assets/icons/dark/checkall.svg";
import success from "../assets/icons/dark/success.svg";
import unchecked from "../assets/icons/dark/unchecked.svg";
import share from "../assets/icons/dark/share.svg";
import logout from "../assets/icons/dark/logout.svg";
import mail from "../assets/icons/dark/mail.svg";
import user from "../assets/icons/dark/user.svg";
import record from "../assets/icons/dark/record.svg";
import mobile from "../assets/icons/dark/mobile.svg";
import database from "../assets/icons/dark/database.svg";
import time from "../assets/icons/dark/time.svg";
import error from "../assets/icons/dark/error.svg";
import warning from "../assets/icons/dark/warning.svg";
import question from "../assets/icons/dark/question.svg";
import desktop from "../assets/icons/dark/desktop.svg";
import group from "../assets/icons/dark/group.svg";
import members from "../assets/icons/dark/members.svg";
import vaults from "../assets/icons/dark/vaults.svg";
import vault from "../assets/icons/dark/vault.svg";
import invite from "../assets/icons/dark/invite.svg";
import trusted from "../assets/icons/dark/trusted.svg";
import removeuser from "../assets/icons/dark/removeuser.svg";
import org from "../assets/icons/dark/org.svg";
import list from "../assets/icons/dark/list.svg";
import remove from "../assets/icons/dark/remove.svg";
import password from "../assets/icons/dark/password.svg";
import admins from "../assets/icons/dark/admins.svg";
import archive from "../assets/icons/dark/archive.svg";
import attachment from "../assets/icons/dark/attachment.svg";
import file from "../assets/icons/dark/file.svg";
import fileVideo from "../assets/icons/dark/file-video.svg";
import filePdf from "../assets/icons/dark/file-pdf.svg";
import fileImage from "../assets/icons/dark/file-image.svg";
import fileCsv from "../assets/icons/dark/file-csv.svg";
import fileCode from "../assets/icons/dark/file-code.svg";
import fileArchive from "../assets/icons/dark/file-archive.svg";
import fileAudio from "../assets/icons/dark/file-audio.svg";
import fileText from "../assets/icons/dark/file-text.svg";
import fileCertificate from "../assets/icons/dark/file-certificate.svg";
import arrowDown from "../assets/icons/dark/arrow-down.svg";
import arrowRight from "../assets/icons/dark/arrow-right.svg";
import arrowLeft from "../assets/icons/dark/arrow-left.svg";
import circleArrowLeft from "../assets/icons/dark/circle-arrow-left.svg";
import circleArrowRight from "../assets/icons/dark/circle-arrow-right.svg";
import favorite from "../assets/icons/dark/favorite.svg";
import qrcode from "../assets/icons/dark/qrcode.svg";
import credit from "../assets/icons/dark/credit.svg";
import discount from "../assets/icons/dark/discount.svg";
import dollar from "../assets/icons/dark/dollar.svg";
import storage from "../assets/icons/dark/storage.svg";
import hirarchy from "../assets/icons/dark/hirarchy.svg";
import web from "../assets/icons/dark/web.svg";
import bank from "../assets/icons/dark/bank.svg";
import login from "../assets/icons/dark/login.svg";
import sim from "../assets/icons/dark/sim.svg";
import wifi from "../assets/icons/dark/wifi.svg";
import passport from "../assets/icons/dark/passport.svg";
import note from "../assets/icons/dark/note.svg";
import custom from "../assets/icons/dark/custom.svg";
import email from "../assets/icons/dark/email.svg";
import fingerprint from "../assets/icons/dark/fingerprint.svg";
import totp from "../assets/icons/dark/totp.svg";
import month from "../assets/icons/dark/month.svg";
import date from "../assets/icons/dark/date.svg";
import phone from "../assets/icons/dark/phone.svg";
import text from "../assets/icons/dark/text.svg";
import clipboard from "../assets/icons/dark/clipboard.svg";
import forbidden from "../assets/icons/dark/forbidden.svg";
import admin from "../assets/icons/dark/admin.svg";
import owner from "../assets/icons/dark/owner.svg";
import userCheck from "../assets/icons/dark/user-check.svg";
import userTimes from "../assets/icons/dark/user-times.svg";
import dashboard from "../assets/icons/dark/dashboard.svg";
import update from "../assets/icons/dark/update.svg";
import themeLight from "../assets/icons/dark/theme-light.svg";
import themeDark from "../assets/icons/dark/theme-dark.svg";
import themeAuto from "../assets/icons/dark/theme-auto.svg";
import suggestion from "../assets/icons/dark/suggestion.svg";
import tools from "../assets/icons/dark/tools.svg";
import display from "../assets/icons/dark/display.svg";
import billing from "../assets/icons/dark/billing.svg";
import usb from "../assets/icons/dark/usb.svg";
import location from "../assets/icons/dark/location.svg";
import key from "../assets/icons/dark/key.svg";
import test from "../assets/icons/dark/test.svg";
import support from "../assets/icons/dark/support.svg";
import checkboxChecked from "../assets/icons/dark/checkbox-checked.svg";
import checkboxUnChecked from "../assets/icons/dark/checkbox-unchecked.svg";
import extension from "../assets/icons/dark/extension.svg";
import celebrate from "../assets/icons/dark/celebrate.svg";
import frozen from "../assets/icons/dark/frozen.svg";
import auditPass from "../assets/icons/dark/audit-pass.svg";
import auditFail from "../assets/icons/dark/audit-fail.svg";
import weak from "../assets/icons/dark/weak.svg";
import reused from "../assets/icons/dark/reused.svg";
import compromised from "../assets/icons/dark/compromised.svg";
import field from "../assets/icons/dark/field.svg";
import heading from "../assets/icons/dark/heading.svg";
import heading1 from "../assets/icons/dark/heading-1.svg";
import heading2 from "../assets/icons/dark/heading-2.svg";
import heading3 from "../assets/icons/dark/heading-3.svg";
import bold from "../assets/icons/dark/bold.svg";
import italic from "../assets/icons/dark/italic.svg";
import strikethrough from "../assets/icons/dark/strikethrough.svg";
import listUl from "../assets/icons/dark/list-ul.svg";
import listOl from "../assets/icons/dark/list-ol.svg";
import listCheck from "../assets/icons/dark/list-check.svg";
import blockquote from "../assets/icons/dark/blockquote.svg";
import line from "../assets/icons/dark/line.svg";
import expand from "../assets/icons/dark/expand.svg";
import collapse from "../assets/icons/dark/collapse.svg";
import code from "../assets/icons/dark/code.svg";
import expired from "../assets/icons/dark/expired.svg";
import history from "../assets/icons/dark/history.svg";
import count from "../assets/icons/dark/count.svg";
import car from "../assets/icons/dark/car.svg";
import idCard from "../assets/icons/dark/id-card.svg";
import health from "../assets/icons/dark/health.svg";
import roadCircleCheck from "../assets/icons/dark/road-circle-check.svg";
import gun from "../assets/icons/dark/gun.svg";
import bell from "../assets/icons/dark/bell.svg";
import usersRectangle from "../assets/icons/dark/users-rectangle.svg";
import adressCard from "../assets/icons/dark/adress-card.svg";
import pills from "../assets/icons/dark/pills.svg";
import steeringWheel from "../assets/icons/dark/steering-wheel.svg";
import carWrench from "../assets/icons/dark/car-wrench.svg";
import refridgerator from "../assets/icons/dark/refrigerator.svg";
import washingMachine from "../assets/icons/dark/wash-machine.svg";
import heat from "../assets/icons/dark/heat.svg";
import airConditioner from "../assets/icons/dark/air-conditioner.svg";
import oven from "../assets/icons/dark/oven.svg";

import lightAdd from "../assets/icons/light/add.svg";
import lightMenu from "../assets/icons/light/menu.svg";
import lightClose from "../assets/icons/light/close.svg";
import lightMore from "../assets/icons/light/more.svg";
import lightDeleteIcon from "../assets/icons/light/delete.svg";
import lightCopy from "../assets/icons/light/copy.svg";
import lightEdit from "../assets/icons/light/edit.svg";
import lightForward from "../assets/icons/light/forward.svg";
import lightBackward from "../assets/icons/light/backward.svg";
import lightCheck from "../assets/icons/light/check.svg";
import lightCancel from "../assets/icons/light/cancel.svg";
import lightGenerate from "../assets/icons/light/generate.svg";
import lightTag from "../assets/icons/light/tag.svg";
import lightTags from "../assets/icons/light/tags.svg";
import lightDropdown from "../assets/icons/light/dropdown.svg";
import lightDropup from "../assets/icons/light/dropup.svg";
import lightChevronDown from "../assets/icons/light/chevron-down.svg";
import lightSettings from "../assets/icons/light/settings.svg";
import lightCloud from "../assets/icons/light/cloud.svg";
import lightLock from "../assets/icons/light/lock.svg";
import lightUnlock from "../assets/icons/light/unlock.svg";
import lightRefresh from "../assets/icons/light/refresh.svg";
import lightExportIcon from "../assets/icons/light/export.svg";
import lightImportIcon from "../assets/icons/light/import.svg";
import lightSearch from "../assets/icons/light/search.svg";
import lightInfo from "../assets/icons/light/info.svg";
import lightInfoRound from "../assets/icons/light/info-round.svg";
import lightDownload from "../assets/icons/light/download.svg";
import lightUpload from "../assets/icons/light/upload.svg";
import lightShow from "../assets/icons/light/show.svg";
import lightHide from "../assets/icons/light/hide.svg";
import lightChecked from "../assets/icons/light/checked.svg";
import lightCheckall from "../assets/icons/light/checkall.svg";
import lightSuccess from "../assets/icons/light/success.svg";
import lightUnchecked from "../assets/icons/light/unchecked.svg";
import lightShare from "../assets/icons/light/share.svg";
import lightLogout from "../assets/icons/light/logout.svg";
import lightMail from "../assets/icons/light/mail.svg";
import lightUser from "../assets/icons/light/user.svg";
import lightRecord from "../assets/icons/light/record.svg";
import lightMobile from "../assets/icons/light/mobile.svg";
import lightDatabase from "../assets/icons/light/database.svg";
import lightTime from "../assets/icons/light/time.svg";
import lightError from "../assets/icons/light/error.svg";
import lightWarning from "../assets/icons/light/warning.svg";
import lightQuestion from "../assets/icons/light/question.svg";
import lightDesktop from "../assets/icons/light/desktop.svg";
import lightGroup from "../assets/icons/light/group.svg";
import lightMembers from "../assets/icons/light/members.svg";
import lightVaults from "../assets/icons/light/vaults.svg";
import lightVault from "../assets/icons/light/vault.svg";
import lightInvite from "../assets/icons/light/invite.svg";
import lightTrusted from "../assets/icons/light/trusted.svg";
import lightRemoveuser from "../assets/icons/light/removeuser.svg";
import lightOrg from "../assets/icons/light/org.svg";
import lightList from "../assets/icons/light/list.svg";
import lightRemove from "../assets/icons/light/remove.svg";
import lightPassword from "../assets/icons/light/password.svg";
import lightAdmins from "../assets/icons/light/admins.svg";
import lightArchive from "../assets/icons/light/archive.svg";
import lightAttachment from "../assets/icons/light/attachment.svg";
import lightFile from "../assets/icons/light/file.svg";
import lightFileVideo from "../assets/icons/light/file-video.svg";
import lightFilePdf from "../assets/icons/light/file-pdf.svg";
import lightFileImage from "../assets/icons/light/file-image.svg";
import lightFileCsv from "../assets/icons/light/file-csv.svg";
import lightFileCode from "../assets/icons/light/file-code.svg";
import lightFileArchive from "../assets/icons/light/file-archive.svg";
import lightFileAudio from "../assets/icons/light/file-audio.svg";
import lightFileText from "../assets/icons/light/file-text.svg";
import lightFileCertificate from "../assets/icons/light/file-certificate.svg";
import lightArrowDown from "../assets/icons/light/arrow-down.svg";
import lightArrowRight from "../assets/icons/light/arrow-right.svg";
import lightArrowLeft from "../assets/icons/light/arrow-left.svg";
import lightCircleArrowLeft from "../assets/icons/light/circle-arrow-left.svg";
import lightCircleArrowRight from "../assets/icons/light/circle-arrow-right.svg";
import lightFavorite from "../assets/icons/light/favorite.svg";
import lightQrcode from "../assets/icons/light/qrcode.svg";
import lightCredit from "../assets/icons/light/credit.svg";
import lightDiscount from "../assets/icons/light/discount.svg";
import lightDollar from "../assets/icons/light/dollar.svg";
import lightStorage from "../assets/icons/light/storage.svg";
import lightHirarchy from "../assets/icons/light/hirarchy.svg";
import lightWeb from "../assets/icons/light/web.svg";
import lightBank from "../assets/icons/light/bank.svg";
import lightLogin from "../assets/icons/light/login.svg";
import lightSim from "../assets/icons/light/sim.svg";
import lightWifi from "../assets/icons/light/wifi.svg";
import lightPassport from "../assets/icons/light/passport.svg";
import lightNote from "../assets/icons/light/note.svg";
import lightCustom from "../assets/icons/light/custom.svg";
import lightEmail from "../assets/icons/light/email.svg";
import lightFingerprint from "../assets/icons/light/fingerprint.svg";
import lightTotp from "../assets/icons/light/totp.svg";
import lightMonth from "../assets/icons/light/month.svg";
import lightDate from "../assets/icons/light/date.svg";
import lightPhone from "../assets/icons/light/phone.svg";
import lightText from "../assets/icons/light/text.svg";
import lightClipboard from "../assets/icons/light/clipboard.svg";
import lightForbidden from "../assets/icons/light/forbidden.svg";
import lightAdmin from "../assets/icons/light/admin.svg";
import lightOwner from "../assets/icons/light/owner.svg";
import lightUserCheck from "../assets/icons/light/user-check.svg";
import lightUserTimes from "../assets/icons/light/user-times.svg";
import lightDashboard from "../assets/icons/light/dashboard.svg";
import lightUpdate from "../assets/icons/light/update.svg";
import lightThemeLight from "../assets/icons/light/theme-light.svg";
import lightThemeDark from "../assets/icons/light/theme-dark.svg";
import lightThemeAuto from "../assets/icons/light/theme-auto.svg";
import lightSuggestion from "../assets/icons/light/suggestion.svg";
import lightTools from "../assets/icons/light/tools.svg";
import lightDisplay from "../assets/icons/light/display.svg";
import lightBilling from "../assets/icons/light/billing.svg";
import lightUsb from "../assets/icons/light/usb.svg";
import lightLocation from "../assets/icons/light/location.svg";
import lightKey from "../assets/icons/light/key.svg";
import lightTest from "../assets/icons/light/test.svg";
import lightSupport from "../assets/icons/light/support.svg";
import lightCheckboxChecked from "../assets/icons/light/checkbox-checked.svg";
import lightCheckboxUnChecked from "../assets/icons/light/checkbox-unchecked.svg";
import lightExtension from "../assets/icons/light/extension.svg";
import lightCelebrate from "../assets/icons/light/celebrate.svg";
import lightFrozen from "../assets/icons/light/frozen.svg";
import lightAuditPass from "../assets/icons/light/audit-pass.svg";
import lightAuditFail from "../assets/icons/light/audit-fail.svg";
import lightWeak from "../assets/icons/light/weak.svg";
import lightReused from "../assets/icons/light/reused.svg";
import lightCompromised from "../assets/icons/light/compromised.svg";
import lightField from "../assets/icons/light/field.svg";
import lightHeading from "../assets/icons/light/heading.svg";
import lightHeading1 from "../assets/icons/light/heading-1.svg";
import lightHeading2 from "../assets/icons/light/heading-2.svg";
import lightHeading3 from "../assets/icons/light/heading-3.svg";
import lightBold from "../assets/icons/light/bold.svg";
import lightItalic from "../assets/icons/light/italic.svg";
import lightStrikethrough from "../assets/icons/light/strikethrough.svg";
import lightListUl from "../assets/icons/light/list-ul.svg";
import lightListOl from "../assets/icons/light/list-ol.svg";
import lightListCheck from "../assets/icons/light/list-check.svg";
import lightBlockquote from "../assets/icons/light/blockquote.svg";
import lightLine from "../assets/icons/light/line.svg";
import lightExpand from "../assets/icons/light/expand.svg";
import lightCollapse from "../assets/icons/light/collapse.svg";
import lightCode from "../assets/icons/light/code.svg";
import lightExpired from "../assets/icons/light/expired.svg";
import lightHistory from "../assets/icons/light/history.svg";
import lightCount from "../assets/icons/light/count.svg";
import lightCar from "../assets/icons/light/car.svg";
import lightIdCard from "../assets/icons/light/id-card.svg";
import lightHealth from "../assets/icons/light/health.svg";
import lightRoadCircleCheck from "../assets/icons/light/road-circle-check.svg";
import lightGun from "../assets/icons/light/gun.svg";
import lightBell from "../assets/icons/light/bell.svg";
import lightUsersRectangle from "../assets/icons/light/users-rectangle.svg";
import lightAdressCard from "../assets/icons/light/adress-card.svg";
import lightPills from "../assets/icons/light/pills.svg";
import lightSteeringWheel from "../assets/icons/light/steering-wheel.svg";
import lightCarWrench from "../assets/icons/light/car-wrench.svg";
import lightRefridgerator from "../assets/icons/light/refrigerator.svg";
import lightWashingMachine from "../assets/icons/light/wash-machine.svg";
import lightHeat from "../assets/icons/light/heat.svg";
import lightAirConditioner from "../assets/icons/light/air-conditioner.svg";
import lightOven from "../assets/icons/light/oven.svg";
import loginUnlock from "../assets/icons/light/login-unlock.svg";
import notFavorite from "../assets/icons/dark/not-favorite.svg";
import lightNotFavorite from "../assets/icons/light/not-favorite-light.svg";
import loginStart from "../assets/icons/dark/login-start.svg";
import headerAdd from "../assets/icons/dark/header-add.svg";
import headerMenuRight from "../assets/icons/dark/menu-right.svg";
import headerMenuLeft from "../assets/icons/dark/menu-left.svg";
import lightCategoryFolder from "../assets/icons/light/category/categoryFolder.svg";
import lightCategoryEmail from "../assets/icons/light/category/categoryEmail.svg";
import lightCategorySetting from "../assets/icons/light/category/categorySetting.svg";
import lightCategoryCar from "../assets/icons/light/category/categoryCar.svg";
import lightCategoryHeart from "../assets/icons/light/category/categoryHeart.svg";
import lightCategoryScreen from "../assets/icons/light/category/categoryScreen.svg";
import lightCategoryEducation from "../assets/icons/light/category/categoryEducation.svg";
import lightCategoryPhone from "../assets/icons/light/category/categoryPhone.svg";
import lightCategoryFridge from "../assets/icons/light/category/categoryFridge.svg";
import lightCategoryPlanet from "../assets/icons/light/category/categoryPlanet.svg";
import lightCategoryShopping from "../assets/icons/light/category/categoryShopping.svg";
import lightCategoryMedical from "../assets/icons/light/category/categoryMedical.svg";
import lightCategoryWifi from "../assets/icons/light/category/categoryWifi.svg";
import lightCategoryNote from "../assets/icons/light/category/categoryNote.svg";
import lightCategoryAirport from "../assets/icons/light/category/categoryAirport.svg";
import lightCategoryContract from "../assets/icons/light/category/categoryContract.svg";
import lightCategoryMoney from "../assets/icons/light/category/categoryMoney.svg";
import lightCategoryPC from "../assets/icons/light/category/categoryPC.svg";
import lightCategorySearch from "../assets/icons/light/category/categorySearch.svg";
import lightCategoryShield from "../assets/icons/light/category/categoryShield.svg";
import lightCategoryWallet from "../assets/icons/light/category/categoryWallet.svg";
import darkCategoryFolder from "../assets/icons/dark/category/categoryFolder.svg";
import darkCategoryEmail from "../assets/icons/dark/category/categoryMail.svg";
import darkCategorySetting from "../assets/icons/dark/category/categorySetting.svg";
import darkCategoryCar from "../assets/icons/dark/category/categoryCar.svg";
import darkCategoryHeart from "../assets/icons/dark/category/categoryHeart.svg";
import darkCategoryScreen from "../assets/icons/dark/category/categoryScreen.svg";
import darkCategoryEducation from "../assets/icons/dark/category/categoryEducation.svg";
import darkCategoryPhone from "../assets/icons/dark/category/categoryPhone.svg";
import darkCategoryFridge from "../assets/icons/dark/category/categoryFridge.svg";
import darkCategoryPlanet from "../assets/icons/dark/category/categoryPlanet.svg";
import darkCategoryShopping from "../assets/icons/dark/category/categoryShopping.svg";
import darkCategoryMedical from "../assets/icons/dark/category/categoryMedical.svg";
import darkCategoryWifi from "../assets/icons/dark/category/categoryWifi.svg";
import darkCategoryNote from "../assets/icons/dark/category/categoryNote.svg";
import darkCategoryAirport from "../assets/icons/dark/category/categoryAirport.svg";
import darkCategoryContract from "../assets/icons/dark/category/categoryContract.svg";
import darkCategoryMoney from "../assets/icons/dark/category/categoryMoney.svg";
import darkCategoryPC from "../assets/icons/dark/category/categoryPC.svg";
import darkCategorySearch from "../assets/icons/dark/category/categorySearch.svg";
import darkCategoryShield from "../assets/icons/dark/category/categoryShield.svg";
import darkCategoryWallet from "../assets/icons/dark/category/categoryWallet.svg";
import change from "../assets/icons/dark/change.svg";
import lightChange from "../assets/icons/light/change.svg";
import alertWeak from "../assets/icons/common/alert-weak.svg";
import alertCompromised from "../assets/icons/common/alert-compromised.svg";
import alertReused from "../assets/icons/common/alert-reused.svg";
import alertExpired from "../assets/icons/common/alert-expired.svg";
import alertAuditFail from "../assets/icons/common/alert-audit-fail.svg";
import star from "../assets/icons/dark/star.svg";
import lightStar from "../assets/icons/light/star.svg";

export const icons: {
    dark: { [key: string]: string };
    light: { [key: string]: string };
    auto: { [key: string]: string };
} = {
    dark: {
        add: add,
        menu: menu,
        close: close,
        more: more,
        delete: deleteIcon,
        copy: copy,
        edit: edit,
        forward: forward,
        backward: backward,
        check: check,
        cancel: cancel,
        generate: generate,
        tag: tag,
        tags: tags,
        dropdown: dropdown,
        dropup: dropup,
        "chevron-down": chevronDown,
        settings: settings,
        cloud: cloud,
        lock: lock,
        unlock: unlock,
        refresh: refresh,
        export: exportIcon,
        import: importIcon,
        search: search,
        info: info,
        "info-round": infoRound,
        download: download,
        upload: upload,
        show: show,
        hide: hide,
        checked: checked,
        checkall: checkall,
        success: success,
        unchecked: unchecked,
        share: share,
        logout: logout,
        mail: mail,
        user: user,
        record: record,
        mobile: mobile,
        database: database,
        time: time,
        error: error,
        warning: warning,
        question: question,
        desktop: desktop,
        group: group,
        members: members,
        vaults: vaults,
        vault: vault,
        invite: invite,
        trusted: trusted,
        removeuser: removeuser,
        org: org,
        list: list,
        remove: remove,
        password: password,
        admins: admins,
        archive: archive,
        attachment: attachment,
        file: file,
        "file-video": fileVideo,
        "file-pdf": filePdf,
        "file-image": fileImage,
        "file-csv": fileCsv,
        "file-code": fileCode,
        "file-archive": fileArchive,
        "file-audio": fileAudio,
        "file-text": fileText,
        "file-certificate": fileCertificate,
        "arrow-down": arrowDown,
        "arrow-right": arrowRight,
        "arrow-left": arrowLeft,
        "circle-arrow-left": circleArrowLeft,
        "circle-arrow-right": circleArrowRight,
        favorite: favorite,
        qrcode: qrcode,
        credit: credit,
        address: credit,
        discount: discount,
        dollar: dollar,
        storage: storage,
        hirarchy: hirarchy,
        web: web,
        bank: bank,
        login: login,
        sim: sim,
        wifi: wifi,
        passport: passport,
        note: note,
        custom: custom,
        email: email,
        fingerprint: fingerprint,
        totp: totp,
        month: month,
        date: date,
        phone: phone,
        text: text,
        clipboard: clipboard,
        forbidden: forbidden,
        admin: admin,
        owner: owner,
        "user-check": userCheck,
        "user-times": userTimes,
        dashboard: dashboard,
        update: update,
        "theme-light": themeLight,
        "theme-dark": themeDark,
        "theme-auto": themeAuto,
        suggestion: suggestion,
        tools: tools,
        display: display,
        billing: billing,
        usb: usb,
        location: location,
        key: key,
        test: test,
        support: support,
        "checkbox-checked": checkboxChecked,
        "checkbox-unchecked": checkboxUnChecked,
        extension: extension,
        celebrate: celebrate,
        frozen: frozen,
        "audit-pass": auditPass,
        "audit-fail": auditFail,
        weak: weak,
        reused: reused,
        compromised: compromised,
        field: field,
        heading: heading,
        "heading-1": heading1,
        "heading-2": heading2,
        "heading-3": heading3,
        bold: bold,
        italic: italic,
        strikethrough: strikethrough,
        "list-ul": listUl,
        "list-ol": listOl,
        "list-check": listCheck,
        blockquote: blockquote,
        line: line,
        expand: expand,
        collapse: collapse,
        markdown: arrowDown,
        code: code,
        expired: expired,
        history: history,
        count: count,
        car: car,
        "id-card": idCard,
        health: health,
        "road-circle-check": roadCircleCheck,
        gun: gun,
        bell: bell,
        "users-rectangle": usersRectangle,
        "adress-card": adressCard,
        pills: pills,
        "steering-wheel": steeringWheel,
        "car-wrench": carWrench,
        refridgerator: refridgerator,
        "washing-machine": washingMachine,
        heat: heat,
        "air-conditioner": airConditioner,
        oven: oven,
        "login-unlock": unlock,
        "login-start": loginStart,
        "not-favorite": notFavorite,
        "primary-check": check,
        "unlock-cancel": cancel,
        "unlock-check": check,
        "add-header": headerAdd,
        "menu-header": headerMenuRight,
        "menu-header-active": headerMenuLeft,
        categoryFolder: darkCategoryFolder,
        categoryEmail: darkCategoryEmail,
        categorySetting: darkCategorySetting,
        categoryCar: darkCategoryCar,
        categoryHeart: darkCategoryHeart,
        categoryScreen: darkCategoryScreen,
        categoryEducation: darkCategoryEducation,
        categoryPhone: darkCategoryPhone,
        categoryFridge: darkCategoryFridge,
        categoryPlanet: darkCategoryPlanet,
        categoryShopping: darkCategoryShopping,
        categoryMedical: darkCategoryMedical,
        categoryWifi: darkCategoryWifi,
        categoryNote: darkCategoryNote,
        categoryAirport: darkCategoryAirport,
        categoryContract: darkCategoryContract,
        categoryMoney: darkCategoryMoney,
        categoryPC: darkCategoryPC,
        categorySearch: darkCategorySearch,
        categoryShield: darkCategoryShield,
        categoryWallet: darkCategoryWallet,
        change: change,
        alertWeak: alertWeak,
        alertCompromised: alertCompromised,
        alertReused: alertReused,
        alertAuditFail: alertAuditFail,
        alertExpired: alertExpired,
        star: star,
    },
    light: {
        add: lightAdd,
        menu: lightMenu,
        close: lightClose,
        more: lightMore,
        delete: lightDeleteIcon,
        copy: lightCopy,
        edit: lightEdit,
        forward: lightForward,
        backward: lightBackward,
        check: lightCheck,
        cancel: lightCancel,
        generate: lightGenerate,
        tag: lightTag,
        tags: lightTags,
        dropdown: lightDropdown,
        dropup: lightDropup,
        "chevron-down": lightChevronDown,
        settings: lightSettings,
        cloud: lightCloud,
        lock: lightLock,
        unlock: lightUnlock,
        refresh: lightRefresh,
        export: lightExportIcon,
        import: lightImportIcon,
        search: lightSearch,
        info: lightInfo,
        "info-round": lightInfoRound,
        download: lightDownload,
        upload: lightUpload,
        show: lightShow,
        hide: lightHide,
        checked: lightChecked,
        checkall: lightCheckall,
        success: lightSuccess,
        unchecked: lightUnchecked,
        share: lightShare,
        logout: lightLogout,
        mail: lightMail,
        user: lightUser,
        record: lightRecord,
        mobile: lightMobile,
        database: lightDatabase,
        time: lightTime,
        error: lightError,
        warning: lightWarning,
        question: lightQuestion,
        desktop: lightDesktop,
        group: lightGroup,
        members: lightMembers,
        vaults: lightVaults,
        vault: lightVault,
        invite: lightInvite,
        trusted: lightTrusted,
        removeuser: lightRemoveuser,
        org: lightOrg,
        list: lightList,
        remove: lightRemove,
        password: lightPassword,
        admins: lightAdmins,
        archive: lightArchive,
        attachment: lightAttachment,
        file: lightFile,
        "file-video": lightFileVideo,
        "file-pdf": lightFilePdf,
        "file-image": lightFileImage,
        "file-csv": lightFileCsv,
        "file-code": lightFileCode,
        "file-archive": lightFileArchive,
        "file-audio": lightFileAudio,
        "file-text": lightFileText,
        "file-certificate": lightFileCertificate,
        "arrow-down": lightArrowDown,
        "arrow-right": lightArrowRight,
        "arrow-left": lightArrowLeft,
        "circle-arrow-left": lightCircleArrowLeft,
        "circle-arrow-right": lightCircleArrowRight,
        favorite: lightFavorite,
        qrcode: lightQrcode,
        credit: lightCredit,
        address: lightCredit,
        discount: lightDiscount,
        dollar: lightDollar,
        storage: lightStorage,
        hirarchy: lightHirarchy,
        web: lightWeb,
        bank: lightBank,
        login: lightLogin,
        sim: lightSim,
        wifi: lightWifi,
        passport: lightPassport,
        note: lightNote,
        custom: lightCustom,
        email: lightEmail,
        fingerprint: lightFingerprint,
        totp: lightTotp,
        month: lightMonth,
        date: lightDate,
        phone: lightPhone,
        text: lightText,
        clipboard: lightClipboard,
        forbidden: lightForbidden,
        admin: lightAdmin,
        owner: lightOwner,
        "user-check": lightUserCheck,
        "user-times": lightUserTimes,
        dashboard: lightDashboard,
        update: lightUpdate,
        "theme-light": lightThemeLight,
        "theme-dark": lightThemeDark,
        "theme-auto": lightThemeAuto,
        suggestion: lightSuggestion,
        tools: lightTools,
        display: lightDisplay,
        billing: lightBilling,
        usb: lightUsb,
        location: lightLocation,
        key: lightKey,
        test: lightTest,
        support: lightSupport,
        "checkbox-checked": lightCheckboxChecked,
        "checkbox-unchecked": lightCheckboxUnChecked,
        extension: lightExtension,
        celebrate: lightCelebrate,
        frozen: lightFrozen,
        "audit-pass": lightAuditPass,
        "audit-fail": lightAuditFail,
        weak: lightWeak,
        reused: lightReused,
        compromised: lightCompromised,
        field: lightField,
        heading: lightHeading,
        "heading-1": lightHeading1,
        "heading-2": lightHeading2,
        "heading-3": lightHeading3,
        bold: lightBold,
        italic: lightItalic,
        strikethrough: lightStrikethrough,
        "list-ul": lightListUl,
        "list-ol": lightListOl,
        "list-check": lightListCheck,
        blockquote: lightBlockquote,
        line: lightLine,
        expand: lightExpand,
        collapse: lightCollapse,
        markdown: lightArrowDown,
        code: lightCode,
        expired: lightExpired,
        history: lightHistory,
        count: lightCount,
        car: lightCar,
        "id-card": lightIdCard,
        health: lightHealth,
        "road-circle-check": lightRoadCircleCheck,
        gun: lightGun,
        bell: lightBell,
        "users-rectangle": lightUsersRectangle,
        "adress-card": lightAdressCard,
        pills: lightPills,
        "steering-wheel": lightSteeringWheel,
        "car-wrench": lightCarWrench,
        refridgerator: lightRefridgerator,
        "washing-machine": lightWashingMachine,
        heat: lightHeat,
        "air-conditioner": lightAirConditioner,
        oven: lightOven,
        "login-unlock": loginUnlock,
        "login-start": loginStart,
        "not-favorite": lightNotFavorite,
        "primary-check": check,
        "unlock-cancel": cancel,
        "unlock-check": check,
        "add-header": headerAdd,
        "menu-header": headerMenuRight,
        "menu-header-active": headerMenuLeft,
        categoryFolder: lightCategoryFolder,
        categoryEmail: lightCategoryEmail,
        categorySetting: lightCategorySetting,
        categoryCar: lightCategoryCar,
        categoryHeart: lightCategoryHeart,
        categoryScreen: lightCategoryScreen,
        categoryEducation: lightCategoryEducation,
        categoryPhone: lightCategoryPhone,
        categoryFridge: lightCategoryFridge,
        categoryPlanet: lightCategoryPlanet,
        categoryShopping: lightCategoryShopping,
        categoryMedical: lightCategoryMedical,
        categoryWifi: lightCategoryWifi,
        categoryNote: lightCategoryNote,
        categoryAirport: lightCategoryAirport,
        categoryContract: lightCategoryContract,
        categoryMoney: lightCategoryMoney,
        categoryPC: lightCategoryPC,
        categorySearch: lightCategorySearch,
        categoryShield: lightCategoryShield,
        categoryWallet: lightCategoryWallet,
        change: lightChange,
        alertWeak: alertWeak,
        alertCompromised: alertCompromised,
        alertReused: alertReused,
        alertAuditFail: alertAuditFail,
        alertExpired: alertExpired,
        star: lightStar,
    },
    auto: {
        add: add,
        menu: menu,
        close: close,
        more: more,
        delete: deleteIcon,
        copy: copy,
        edit: edit,
        forward: forward,
        backward: backward,
        check: check,
        cancel: cancel,
        generate: generate,
        tag: tag,
        tags: tags,
        dropdown: dropdown,
        dropup: dropup,
        "chevron-down": chevronDown,
        settings: settings,
        cloud: cloud,
        lock: lock,
        unlock: unlock,
        refresh: refresh,
        export: exportIcon,
        import: importIcon,
        search: search,
        info: info,
        "info-round": infoRound,
        download: download,
        upload: upload,
        show: show,
        hide: hide,
        checked: checked,
        checkall: checkall,
        success: success,
        unchecked: unchecked,
        share: share,
        logout: logout,
        mail: mail,
        user: user,
        record: record,
        mobile: mobile,
        database: database,
        time: time,
        error: error,
        warning: warning,
        question: question,
        desktop: desktop,
        group: group,
        members: members,
        vaults: vaults,
        vault: vault,
        invite: invite,
        trusted: trusted,
        removeuser: removeuser,
        org: org,
        list: list,
        remove: remove,
        password: password,
        admins: admins,
        archive: archive,
        attachment: attachment,
        file: file,
        "file-video": fileVideo,
        "file-pdf": filePdf,
        "file-image": fileImage,
        "file-csv": fileCsv,
        "file-code": fileCode,
        "file-archive": fileArchive,
        "file-audio": fileAudio,
        "file-text": fileText,
        "file-certificate": fileCertificate,
        "arrow-down": arrowDown,
        "arrow-right": arrowRight,
        "arrow-left": arrowLeft,
        "circle-arrow-left": circleArrowLeft,
        "circle-arrow-right": circleArrowRight,
        favorite: favorite,
        qrcode: qrcode,
        credit: credit,
        address: credit,
        discount: discount,
        dollar: dollar,
        storage: storage,
        hirarchy: hirarchy,
        web: web,
        bank: bank,
        login: login,
        sim: sim,
        wifi: wifi,
        passport: passport,
        note: note,
        custom: custom,
        email: email,
        fingerprint: fingerprint,
        totp: totp,
        month: month,
        date: date,
        phone: phone,
        text: text,
        clipboard: clipboard,
        forbidden: forbidden,
        admin: admin,
        owner: owner,
        "user-check": userCheck,
        "user-times": userTimes,
        dashboard: dashboard,
        update: update,
        "theme-light": themeLight,
        "theme-dark": themeDark,
        "theme-auto": themeAuto,
        suggestion: suggestion,
        tools: tools,
        display: display,
        billing: billing,
        usb: usb,
        location: location,
        key: key,
        test: test,
        support: support,
        "checkbox-checked": checkboxChecked,
        "checkbox-unchecked": checkboxUnChecked,
        extension: extension,
        celebrate: celebrate,
        frozen: frozen,
        "audit-pass": auditPass,
        "audit-fail": auditFail,
        weak: weak,
        reused: reused,
        compromised: compromised,
        field: field,
        heading: heading,
        "heading-1": heading1,
        "heading-2": heading2,
        "heading-3": heading3,
        bold: bold,
        italic: italic,
        strikethrough: strikethrough,
        "list-ul": listUl,
        "list-ol": listOl,
        "list-check": listCheck,
        blockquote: blockquote,
        line: line,
        expand: expand,
        collapse: collapse,
        markdown: arrowDown,
        code: code,
        expired: expired,
        history: history,
        count: count,
        car: car,
        "id-card": idCard,
        health: health,
        "road-circle-check": roadCircleCheck,
        gun: gun,
        bell: bell,
        "users-rectangle": usersRectangle,
        "adress-card": adressCard,
        pills: pills,
        "steering-wheel": steeringWheel,
        "car-wrench": carWrench,
        refridgerator: refridgerator,
        "washing-machine": washingMachine,
        heat: heat,
        "air-conditioner": airConditioner,
        oven: oven,
        "login-start": loginStart,
        "login-unlock": loginUnlock,
        "not-favorite": notFavorite,
        "primary-check": check,
        "unlock-cancel": cancel,
        "unlock-check": check,
        "add-header": headerAdd,
        "menu-header": headerMenuRight,
        "menu-header-active": headerMenuLeft,
        categoryFolder: darkCategoryFolder,
        categoryEmail: darkCategoryEmail,
        categorySetting: darkCategorySetting,
        categoryCar: darkCategoryCar,
        categoryHeart: darkCategoryHeart,
        categoryScreen: darkCategoryScreen,
        categoryEducation: darkCategoryEducation,
        categoryPhone: darkCategoryPhone,
        categoryFridge: darkCategoryFridge,
        categoryPlanet: darkCategoryPlanet,
        categoryShopping: darkCategoryShopping,
        categoryMedical: darkCategoryMedical,
        categoryWifi: darkCategoryWifi,
        categoryNote: darkCategoryNote,
        categoryAirport: darkCategoryAirport,
        categoryContract: darkCategoryContract,
        categoryMoney: darkCategoryMoney,
        categoryPC: darkCategoryPC,
        categorySearch: darkCategorySearch,
        categoryShield: darkCategoryShield,
        categoryWallet: darkCategoryWallet,
        change: change,
        alertWeak: alertWeak,
        alertCompromised: alertCompromised,
        alertReused: alertReused,
        alertAuditFail: alertAuditFail,
        alertExpired: alertExpired,
        star: star,
    },
};
